import React, { Component } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./styles.scss";

const InputBlock = ({title = true}) => {
  return (

    <div className={title ? "profile-field-wrapper" : 'profile-field-wrapper without-title'}>
      {title && <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <Skeleton width={88} height={16} />
      </div>}
      <Skeleton width={"100%"} height={48} style={{ marginTop:8}} />
    </div>
  );
};
class ProfileLoader extends Component {
  render() {
    return (
      <div className="profile-loader">
        <SkeletonTheme color="#848484" highlightColor="#373737">
          <div className="profile-wrapper">
            <div className="profile-tag">
              <div className="profile-title-wrapper">
                <div className="profile-title">
                  <Skeleton width={120} height={40} />
                </div>
              </div>
            </div>
          </div>
          <div className="profile-wrapper">
            <div className="account-details-wrapper">
              <div className="account-details">
                <div className="account-logo">
                  <Skeleton circle={true} height={100} width={100} />
                </div>
                <div className="details-wrapper">
                  <div className="details-info">
                    <Skeleton width={136} height={16} style={{ marginLeft: 8 }} />
                  </div>
                  <div className="details-info">
                    <Skeleton width={136} height={16} style={{ marginLeft: 8 }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="profile-wrapper">
            <InputBlock />
            <InputBlock />
          </div>
          <div className="profile-wrapper">
            <InputBlock />
          </div>
          <div className="profile-wrapper">
            <InputBlock />
            <InputBlock title ={false}/>
          </div>
          <div className="profile-wrapper">
            <InputBlock />
          </div>
          <div className="profile-wrapper">
            <InputBlock />
          </div>
          <div className="profile-wrapper">
            <div className="profile-field-wrapper">
              <div className="save-btn">
                <Skeleton width={"100%"} height={44} style={{ borderRadius: 100 }}
                />
              </div>
            </div>
          </div>
        </SkeletonTheme>
      </div>
    );
  }
}

export default ProfileLoader;
